<!--
 * @Author: lixiang
 * @Date: 2026-10-23 09:59:52
 * @Description: Description
 * @FilePath: /Flash/flashhr/backyard-ms/src/views/test/fileToUpload/index.vue
 * @LastEditTime: 2026-10-26 16:40:31
 * @LastEditors: lixiangyun@flashexpress.com
-->
<template>
  <div style="display: flex; align-items: center; width: 100%;">
    <UploadModule :fileLimit="100" :showFile="false" @success="handleSuccess" />

     <!-- 上传后地址 -->
    <div style="flex: 1; margin-left: 20px;">
      <el-input v-model="objectUrl" style="max-width: inherit;">
        <el-button slot="append" icon="el-icon-document-copy" @click="copyToClipboard">复制</el-button>
      </el-input>
    </div>
  </div>
</template>

<script>
import UploadModule from '@/components/upload/index.vue'
export default {
  name: 'fileToUpload',
  components: {
    UploadModule
  },
  data() {
    return {
      objectUrl: '' // 上传后地址
    }
  },
  methods: {
    /**
     * @description: 
     * @return {*}
     */    
     async copyToClipboard() {
      if (!this.objectUrl) {
        this.$message.warning('Please upload the file first')
        return
      }
      
      try {
        await this.$copyText(this.objectUrl)
        this.$message.success('Copied to clipboard')
      } catch (error) {
        this.$message.error('Copy failed')
      }
    },
    /**
     * @description: 上传成功回调
     * @param {*} fileList
     * @return {*}
     */    
    handleSuccess(fileList) {
      if (Array.isArray(fileList) && fileList.length > 0) {
        this.objectUrl = fileList[fileList.length - 1].object_url // 仅获取最后一个文件的地址
      }
    }
  }
}
</script>

<style scoped>

</style>